var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteInactiveError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    className: "icon",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1c293a",
    d: "M262.74 73.23h234.574c20.118 0 36.614-16.498 36.614-36.615S517.432 0 497.314 0H262.739c-20.117 0-36.614 16.497-36.614 36.615 0 20.52 16.497 36.614 36.614 36.614zm460.699 90.932H36.615C16.497 164.162 0 180.659 0 200.776s16.497 36.615 36.615 36.615H63.17l49.892 494.9c4.024 41.443 39.03 72.826 80.472 72.826h375.802c41.443 0 76.046-31.383 80.471-72.826l49.893-494.9h23.739c20.118 0 36.614-16.497 36.614-36.615-.402-20.52-16.496-36.614-36.614-36.614zM416.44 587.844c0 20.118-16.497 36.615-36.614 36.615s-36.615-16.497-36.615-36.615v-187.9c0-20.118 16.497-36.615 36.615-36.615s36.614 16.497 36.614 36.614v187.901z",
    "data-spm-anchor-id": "a313x.search_index.0.i6.44de3a81lGptBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D81E06",
    d: "M747.58 402.358c-151.688 0-274.408 123.121-274.408 274.407 0 151.69 123.122 274.408 274.408 274.408s274.408-123.121 274.408-274.408S898.867 402.358 747.58 402.358zm17.302 440.983c-10.462 6.438-23.74 6.438-34.603 0-10.864-6.437-17.301-17.703-17.301-30.176 0-12.473 6.437-24.142 17.301-30.177 10.461-6.438 23.74-6.438 34.603 0 10.863 6.438 17.703 17.704 17.301 30.177 0 12.473-6.438 23.739-17.301 30.176zm17.301-153.7c0 18.91-15.692 34.603-34.603 34.603-18.91 0-34.602-15.692-34.602-34.603V540.366c0-18.91 15.692-34.603 34.602-34.603 18.911 0 34.603 15.692 34.603 34.603v149.275z",
    className: "selected",
    "data-spm-anchor-id": "a313x.search_index.0.i7.44de3a81lGptBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteInactiveError);
export default __webpack_public_path__ + "static/media/delete-inactive-error.6238f930d125dbfab89d4354c6f3c382.svg";
export { ForwardRef as ReactComponent };